<template>
  <component
    :is="tag"
    class="heading"
    :class="[
      levelClasses,
      colorClasses,
      variantClasses
    ]"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  level: {
    type: [Number, String],
    default: 1,
    validator: val => [1, 2, 3, 4, 5, 6].includes(Number(val))
  },
  color: {
    type: String,
    default: 'primary',
    validator: val => ['default', 'primary', 'muted', 'accent', 'coral', 'orange'].includes(val)
  },
  variant: {
    type: String,
    default: 'default',
    validator: val => ['default', 'display', 'hero'].includes(val)
  }
})

const tag = computed(() => `h${props.level}`)

const levelClasses = computed(() => {
  const baseClasses = {
    1: 'text-h1 font-bold',
    2: 'text-h2 font-semibold', 
    3: 'text-body-large font-semibold',
    4: 'text-body font-medium',
    5: 'text-body-small font-medium',
    6: 'text-label font-medium'
  }
  
  if (props.variant === 'display') {
    return {
      1: 'text-display-1 font-black',
      2: 'text-display-2 font-bold',
      3: 'text-display-3 font-bold',
      4: 'text-display-4 font-semibold',
      5: 'text-display-5 font-medium',
      6: 'text-display-6 font-medium'
    }[Number(props.level)] || baseClasses[1]
  }
  
  if (props.variant === 'hero') {
    return {
      1: 'text-display-1 font-black',
      2: 'text-display-2 font-bold',
      3: 'text-display-3 font-bold',
      4: 'text-display-4 font-semibold',
      5: 'text-display-5 font-medium',
      6: 'text-display-6 font-medium'
    }[Number(props.level)] || baseClasses[1]
  }
  
  return baseClasses[Number(props.level)] || baseClasses[1]
})

const colorClasses = computed(() => {
  switch (props.color) {
    case 'primary':
      return 'text-on-surface'
    case 'muted':
      return 'text-on-surface-variant'
    case 'accent':
      return 'text-primary'
    case 'coral':
      return 'text-secondary'
    case 'orange':
      return 'text-tertiary'
    case 'default':
    default:
      return 'text-on-surface'
  }
})

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'display':
      return 'font-display'
    case 'hero':
      return 'font-display text-gradient'
    case 'default':
    default:
      return 'font-display'
  }
})
</script>
